import { Alert, Box, Typography } from '@mui/material';
import { memo, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { ResultCard } from '../../../components/translate/ResultCard';
import type { TranslationResult } from '../../../types';

interface TranslationResultsPanelProps {
  errorMessage: string | null;
  infoMessage?: string | null;
  jobProgress?: ReactNode;
  results: TranslationResult[];
  onDownload: (result: TranslationResult) => Promise<void>;
}

export const TranslationResultsPanel = memo(function TranslationResultsPanel({
  errorMessage,
  infoMessage,
  jobProgress,
  results,
  onDownload,
}: TranslationResultsPanelProps) {
  const { t } = useTranslation();

  return (
    <>
      {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
      {infoMessage && <Alert severity="info">{infoMessage}</Alert>}
      {jobProgress}

      <Box className="min-h-0 flex-1 space-y-4 overflow-y-auto p-4">
        {results.length === 0 ? (
          <Box className="flex h-full min-h-[240px] items-center justify-center text-center">
            <Typography variant="body2" className="text-gray-500 dark:text-slate-500">
              {t('translate.response.empty')}
            </Typography>
          </Box>
        ) : (
          results.map((result) => (
            <ResultCard key={result.id} result={result} onDownload={onDownload} />
          ))
        )}
      </Box>
    </>
  );
});
